export default [
  {
    title: 'breadcrumb.administrator',
    route: 'list-administrator',
    icon: '',
    resource: 'administrator',
    action: 'read'
  }
];